const USER_MANAGER_CONFIG_KEY = "oidcSettings";
const USER_KEY = "user";
const IMPERSONATION_KEY = "impersonation";
const SETTINGS_KEY = "settings";
const LOGIN_METADATA_KEY = "login_metadata";
const LOGIN_SIGNIN_KEYS_KEY = "login_signin_keys";
const RETURN_URL_KEY = "return_url";
const DESKTOP_SIDEBAR_STATUS = "desktop_sidebar_status";
const CATEGORY_ICONS_KEY = "category_icons";
class Storage {
    get User() {
        return JSON.parse(window.localStorage.getItem(USER_KEY));
    }
    set User(user) {
        window.localStorage.setItem(USER_KEY, JSON.stringify(user));
    }
    hasUser() {
        return window.localStorage.getItem(USER_KEY) !== null;
    }
    removeUser() {
        window.localStorage.removeItem(USER_KEY);
    }
    get Impersonation() {
        return JSON.parse(window.localStorage.getItem(IMPERSONATION_KEY));
    }
    set Impersonation(impersonation) {
        window.localStorage.setItem(IMPERSONATION_KEY, JSON.stringify(impersonation));
    }
    hasImpersonation() {
        return window.localStorage.getItem(IMPERSONATION_KEY) !== null;
    }
    get Roles() {
        const rolesField = this.hasImpersonation()
            ? this.Impersonation && this.Impersonation.roles
            : this.User && this.User.profile && this.User.profile.roles;
        const roles = rolesField.reduce((accum, roleItem) => {
            if (roleItem.startsWith("v1-")) {
                accum[roleItem] = roleItem;
            }
            else {
                const sliceIndex = roleItem.indexOf(":");
                const key = roleItem.slice(0, sliceIndex);
                const value = roleItem.slice(sliceIndex + 1).split(",");
                accum[key] = value;
            }
            return accum;
        }, {});
        return roles;
    }
    get UserManagerConfig() {
        return JSON.parse(window.localStorage.getItem(USER_MANAGER_CONFIG_KEY));
    }
    set UserManagerConfig(config) {
        window.localStorage.setItem(USER_MANAGER_CONFIG_KEY, JSON.stringify(config));
    }
    hasUserManagerConfig() {
        return window.localStorage.getItem(USER_MANAGER_CONFIG_KEY) !== null;
    }
    get Settings() {
        return JSON.parse(window.localStorage.getItem(SETTINGS_KEY));
    }
    set Settings(settings) {
        window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    }
    hasSettings() {
        return window.localStorage.getItem(SETTINGS_KEY) !== null;
    }
    get LoginMetadata() {
        return JSON.parse(window.localStorage.getItem(LOGIN_METADATA_KEY));
    }
    set LoginMetadata(metadata) {
        window.localStorage.setItem(LOGIN_METADATA_KEY, JSON.stringify(metadata));
    }
    hasLoginMetadata() {
        return window.localStorage.getItem(LOGIN_METADATA_KEY) !== null;
    }
    get LoginSigninKeys() {
        return JSON.parse(window.localStorage.getItem(LOGIN_SIGNIN_KEYS_KEY));
    }
    set LoginSigninKeys(keys) {
        window.localStorage.setItem(LOGIN_SIGNIN_KEYS_KEY, JSON.stringify(keys));
    }
    hasLoginSigninKeys() {
        return window.localStorage.getItem(LOGIN_SIGNIN_KEYS_KEY) !== null;
    }
    get ReturnUrl() {
        return window.localStorage.getItem(RETURN_URL_KEY);
    }
    set ReturnUrl(url) {
        window.localStorage.setItem(RETURN_URL_KEY, url);
    }
    removeReturnUrl() {
        return window.localStorage.removeItem(RETURN_URL_KEY);
    }
    hasReturnUrl() {
        return window.localStorage.getItem(RETURN_URL_KEY) !== null;
    }
    get hasDesktopSidebarStatus() {
        return window.localStorage.getItem(DESKTOP_SIDEBAR_STATUS) !== null;
    }
    get desktopSidebarStatus() {
        return JSON.parse(window.localStorage.getItem(DESKTOP_SIDEBAR_STATUS));
    }
    set desktopSidebarStatus(status) {
        window.localStorage.setItem(DESKTOP_SIDEBAR_STATUS, JSON.stringify(status));
    }
    get CategoryIcons() {
        return JSON.parse(window.localStorage.getItem(CATEGORY_ICONS_KEY));
    }
    set CategoryIcons(icons) {
        window.localStorage.setItem(CATEGORY_ICONS_KEY, JSON.stringify(icons));
    }
}
export default new Storage();
